// TODO fill in the rest of these options
export enum ConditionEvent {
    RECEIVED = 'RECEIVED'
}

export const conditionEventDisplay = {
    [ConditionEvent.RECEIVED]: 'Received'
};
